import React from 'react';
import PropTypes from 'prop-types';
import GeneralOfferFormContainer from './GeneralOfferLayout/GeneralOfferFormContainer';

// TODO: DELETE THIS COMPONENT IN FUTURE RELEASES~!

const GeneralOfferLayout = ({ token }) => (
  <div className="general-offer-container">
    <div className="general-offer-layout">
      <div className="general-offer-content">
        <GeneralOfferFormContainer token={token} />
      </div>
    </div>
  </div>
);

GeneralOfferLayout.propTypes = {
  token: PropTypes.string.isRequired,
};
export default GeneralOfferLayout;
